export default class AdvertisingProviderService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('advertisingProviders/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('advertisingProviders', params)
	}

	createEntity(params) {
		return this.apiService.callPost('advertisingProviders', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('advertisingProviders/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('advertisingProviders/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/AdvertisingProviderService.js